import { Text, ThemeColorVariable, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import { SafeHTML } from "components/safe-html";

interface TimeSetCommentProps {
    comment: string;
}

const TimeSetComment = ({ comment }: TimeSetCommentProps) => {
    return (
        <Text mt={ThemeSpaceVariable.XSmall} color={ThemeColorVariable.OnBackgroundSubdued}>
            <SafeHTML html={comment} />
        </Text>
    );
};

export default TimeSetComment;
